import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";
import { blogTagCRUDApi } from "../constants/apis";

// Get all blog tags
export const getBlogTags = async (query = "") => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogTagCRUDApi}${query}`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog tags:", error);
        throw error;
    }
};

// Get single blog tag
export const getBlogTag = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.get(
            `${blogTagCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error fetching blog tag:", error);
        throw error;
    }
};

// Create blog tag
export const createBlogTag = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.post(
            blogTagCRUDApi,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error creating blog tag:", error);
        throw error;
    }
};

// Update blog tag
export const updateBlogTag = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.put(
            `${blogTagCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error updating blog tag:", error);
        throw error;
    }
};

// Patch blog tag
export const patchBlogTag = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.patch(
            `${blogTagCRUDApi}${id}/`,
            data,
            config
        );
        return response;
    } catch (error) {
        console.error("Error patching blog tag:", error);
        throw error;
    }
};

// Delete blog tag
export const deleteBlogTag = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    try {
        const response = await axios.delete(
            `${blogTagCRUDApi}${id}/`,
            config
        );
        return response;
    } catch (error) {
        console.error("Error deleting blog tag:", error);
        throw error;
    }
};
